/* <jp-carousel> — free-scrolling horizontal carousel used by
   sections/jp-carousel.liquid. Consumes the theme's <prev-next-buttons>
   events (prev-next:prev / prev-next:next) and keeps the arrow disabled
   state in sync with the scroll position. Drag-to-scroll comes from the
   theme's <scrollable-content> element used as the track. */

if (!customElements.get("jp-carousel")) {
  customElements.define(
    "jp-carousel",
    class JPCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector(".jp-carousel__track");
        this.prevNextButtons = this.querySelector("prev-next-buttons");

        if (!this.track) return;

        this.addEventListener("prev-next:prev", () => this.scrollBySlide(-1));
        this.addEventListener("prev-next:next", () => this.scrollBySlide(1));
        this.track.addEventListener("scroll", () => this.updateButtons(), {
          passive: true,
        });

        this.resizeObserver = new ResizeObserver(() => this.updateButtons());
        this.resizeObserver.observe(this.track);

        /* Keep the slide selected in the theme editor in view. */
        if (window.Shopify && window.Shopify.designMode) {
          this.addEventListener("shopify:block:select", (event) => {
            event.target.scrollIntoView({
              behavior: "smooth",
              inline: "center",
              block: "nearest",
            });
          });
        }

        this.updateButtons();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      scrollBySlide(direction) {
        const slide = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const amount = slide
          ? slide.clientWidth + gap
          : this.track.clientWidth * 0.8;
        this.track.scrollBy({ left: direction * amount, behavior: "smooth" });
      }

      updateButtons() {
        if (!this.prevNextButtons) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;

        /* Only reveal the prev arrow once the first slide is mostly
           (~75%) scrolled out of view — a couple of pixels of drift
           shouldn't surface it. Capped at maxScroll so short tracks can
           still reveal it at the end of their scroll range. */
        const firstSlide = this.track.firstElementChild;
        const revealThreshold = Math.min(
          firstSlide ? firstSlide.clientWidth * 0.75 : 1,
          Math.max(maxScroll - 1, 1),
        );

        this.prevNextButtons.isPrevDisabled =
          this.track.scrollLeft < revealThreshold;
        this.prevNextButtons.isNextDisabled =
          this.track.scrollLeft >= maxScroll - 1;
      }
    },
  );
}
